import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import MUIDataTable, {
  MUIDataTableColumnDef,
  MUIDataTableOptions,
} from "mui-datatables";
import { MuiThemeProvider, useTheme } from "@material-ui/core/styles";
import update from "immutability-helper";
import moment from "moment";
import Countdown from "react-countdown";

import {
  createTheme,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@material-ui/core";
import copy from "copy-to-clipboard";
import {
  faEdit,
  faHeart,
  faShareSquare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import PubSub from "pubsub-js";
import IRouterComponentProps from "../../../../models/IRouterComponentProps";
import AuthService from "../../../auth/AuthService";
import {
  annualBidUrl,
  annualMyLatestBidsForUser,
  annualMyWatchedProducts,
  getAnnualBidInfo,
  productDownload,
  productUrl,
} from "../../../../common/config/app.endpoints";
import {
  StyledButton,
  StyledModal,
} from "../../../../common/materials/GenericStyleComponent";
import AnnualBidPopup from "../../../products/preview/bidPopupComponent/AnnualBidPopup";
import AlertReadOnlyUser from "../../../../common/elements/AlertReadOnlyUser";
import BlockUserModal from "../../../products/BlockUser/BlockUserModal";
import LoadingSpinner from "../../../../common/elements/LoadingSpinner";
import {
  StyledActionsContainer,
  StyledBackBtn,
  StyledBackImageContianer,
  StyledHeaderContainer,
  StyledName,
  StyledSelectAllButtonHeader,
  StyledTextWrapper,
} from "../DiamondProductStyle";
import {
  StyledButtonView,
  Styledview,
} from "../../../products/preview/TendorPreviewView";
import ApiTimeout from "../../../../modules/ApiTimeout";
import { oAuth } from "../../../../routes/basic/BasicAppRouter";
import { openJewelleryCertificateLinkPopup } from "../../../../common/GenericFunctions";
import EllipsisText from "../../../../common/elements/EllipsisText";
import {
  convertedValue,
  getMyLatestStoredBids,
  getReturnMyLatestStoredBid,
} from "../../../products/preview/TenderGenericFunc";
import JwlProductGridDataParent from "../mobileUi/JwlProductGridDataParent";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../../redux/store";
import { RootState } from "../../../../redux/reducer";
import {
  resetAnnualJewelleryCurrentApiStartCount,
  resetAnnualJewelleryItemPerPage,
  selectAnnualJewelleryCurrentApiStartCount,
  selectAnnualJewelleryItemPerPage,
  setAnnualJewelleryCurrentApiStartCount,
  setAnnualJewelleryItemPerPage,
} from "../../../../redux/slice/commanPagination/commanPaginationSlice";
import JewelleryAnnualActionPage from "../../../core-grid/grid-actions/JewelleryAnnualActionPage";
import {
  resetGridProductWatchlistIndexes,
  resetIsGridView,
  resetjewelleryWatchlistSelectAll,
  selectGridView,
  setGridProductWatchlistIndexes,
  setIsGridView,
  setjewelleryWatchlistSelectAll,
} from "../../../../redux/slice/annual/commanAnnualSlice";
import ProductBiddingUiWatchlist from "../biddingUi/ProductBiddingUiWatchlist";
import ProductGridDataChildComponentWatchlist from "../mobileUi/ProductGridDataChildComponentWatchlist";

const faEditProps = faEdit as IconProp;
const faHeartProps = faHeart as IconProp;
const faShareSquareProps = faShareSquare as IconProp;

const StyledLayoutGridMain = styled(Grid)`
  .MuiIconButton-edgeEnd {
    display: contents !important;
    transition: width 5s !important;
  }
  .MuiAccordionSummary-root {
    min-height: 10px !important;
    transition: width 4s !important;
  }
  .MuiPaper-root {
    box-shadow: none !important;
  }
  .AccordionHeader {
    width: 100%;
    transition: width 1s;

    @keyframes fadeMe {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    ${(props) => props.theme.breakpoints.down("md")} {
      width: 100%;
    }
    ${(props) => props.theme.breakpoints.between("xs", "md")} {
      top: 46px;
      width: 100% !important;
    }
  }
  ${(props) => props.theme.breakpoints.between("xs", "md")} {
    padding: 10px 10px;
  }
`;

const StyledLayoutGrid = styled(Grid)`
  .MuiPaper-root {
    width: 100%;
  }
  .MuiTableCell-root {
    padding: 7px;
    border: 1px solid lightgray;
  }

  .MuiToolbar-regular {
    min-height: 0px;
  }
  .MuiTableCell-head {
    background: #5b9bd5;
    color: white;
    text-align: center;
    font-weight: 700;
    border: 1px solid lightgray;
  }

  .MuiTableCell-root {
    text-align: center;
    max-width: 100px;
  }

  .MuiTableCell-head .MuiButton-root {
    color: white;
    text-align: center;
    font-weight: 700;
  }

  ${(props) => props.theme.breakpoints.between("xs", "md")} {
    padding: 10px 10px;
  }
  .linkCss {
    text-decoration: underline;
    color: blue;
    cursor: pointer;
  }

  .buttonGray {
    background: ${(props) => props.theme.colors.base.gray};
  }

  .MuiTableCell-footer {
    padding: 2px;
    font-size: 0.2em;
    height: 40px;
  }
`;
const StyledBtnContainer = styled.div`
  text-align: center;
`;

const StyledCoreDataGridContainer = styled(Grid)``;
const StyledActionBarContainer = styled(Grid)`
  align-items: center;
  padding: 10px;
  margin: 10px 0px 10px 0px;
  border-radius: 5px;
  box-shadow: 2px 0px 5px 2px ${(props) => props.theme.colors.base.lightGrey};
  justify-content: flex-end;
  &:focus {
    outline: none;
  }
`;
const StyledContent = styled(Grid)`
  text-align: center;
  font-size: 1.3em;
  font-family: "Calibre-Regular";
  color: ${(props) => props.theme.colors.base.textColor};
  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    font-size: 1.1em;
    margin-top: 0.4em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export const StyledButtonGray = styled.button`
  color: ${(props) => props.theme.colors.base.black};
  border: none;
  font-size: 0.8em;
  padding: 0.6em;
  margin: 0.3em;
  border-radius: 5px;
  background: ${(props) => props.theme.colors.base.gray};
  border: 1px solid ${(props) => props.theme.colors.base.white};
`;

const StyledButtonHeader = styled.button`
  color: ${(props) => props.theme.colors.base.grey};
  font-size: 0.9em;
  padding: 0.4em;
  margin: 0.3em;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.base.lightGrey};
  background: ${(props) => props.theme.colors.base.veryVeryLightGrey};
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.base.textColor};
    cursor: pointer;
  }

  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    font-size: 0.8em;
  }
`;

const StyledTabLayout = styled(Grid)``;

export interface IProductViewProps extends IRouterComponentProps {
  setShowAlertMessage: any;
  setOpenToast: any;
  setAlertType: any;
  handleBackBtns: any;
  removeFromWatchlist: any;
}

let data: any = {};
let totalElement: number = 0;
let page: number = 0;

let payload: any = {};
let startCount: number = 0;
let endCount: number = 20;
let rowSelectedData: any;
let updatedRowData: any;
let updateRowIndex: any;
let auctionProductResult: any;
let seconds: any = "";

let filter: any = [];
let jwlFilteredValues: any = "";
let body: any = [];
let auctionName: string = "";

let details: any;
let length: any;

let auctionId: any;
let jwlAuctionUserId: any;
let joinedAnnualAuctions: any = [];

const columnIndexes = {
  serialNo: 0,
  perId: 1,
  auctionUserId: 2,
  productCode: 5,
  lab: 6,
  certificate: 7,
  description: 8,
  currency: 9,
  remarks: 10,
  notes: 11,
  peicePerCt: 12,
  myLatestBids: 13,
  currentBidPrice: 14,
  noOfBids: 15,
  rowColor: 16,
  exchangeRate: 17,
  noOfBidders: 20,
  currentBidValue: 17,
  hieghestBidValue: 18,
  watched: 21,
  sellerAuctionUserId: 22,
  previousHighestBidder: 24,
  productStartDate: 25,
  productExtended: 26,
  holdPreviousBidder: 27,
};
let date: string | string[] = "";
let auctionDate: any;
let indexsForBulkBidItems: any = [];
let myLatestBidForProduct: any = [];
let isReadOnlyUser: any;
let isAuctionUserId: boolean;
let joinedAuctions: any = [];

const initialState = {
  mouseX: null,
  mouseY: null,
};

const JewelleryProductAuctionWatchlist = (props: IProductViewProps) => {
  let { setShowAlertMessage, setOpenToast, setAlertType, handleBackBtns } =
    props;

  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTableSelectCell: {
          fixedHeader: {
            background: "white",
          },
          fixedLeft: {
            background: "white",
          },
        },
      },
    });

  const [auctionProducts, setAuctionProducts] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShowSearchBox, setShowSearchBox] = useState<boolean>(true);
  const [apiTimeout, setApiTimeout] = useState<boolean>(false);
  const [onAction, setOnAction] = useState<boolean>(false);
  const [isFiltersOpen, setIsFiltersOpen] = useState<boolean>(false);
  const [userBlock, setUserBlock] = useState<boolean>(false);
  const [textSearchArray, setTextSearchArray] = useState([]);
  const [optionValue, setOptionValue] = useState("");
  const [showTenderSlider, setshowTenderSlider] = useState<boolean>(false);
  const [uiBoxView, setUiBoxView] = useState<boolean>(false);
  const [showBulkBidPopup, setShowBulkBidPopup] = useState<boolean>(false);
  const [showBulkBidButton, setShowBulkBidButton] = useState<boolean>(false);
  const [isDataRefresh, setIsDataRefresh] = useState<boolean>(false);
  const [isDataTableRefresh, setIsDataTableRefresh] = useState<boolean>(false);
  const [isTopElementHide, setIsTopElementHide] = useState<boolean>(false);
  const [isTopElement, setIsTopElement] = useState<boolean>(false);
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [isSelected, setIsSelected] = useState<boolean>(false);
  const [openReadOnlyUserToast, setOpenReadOnlyUserToast] =
    useState<boolean>(false);
  const [isSort, setIsSort] = useState<boolean>(false);
  const [isTableExpanded, setIsTableExpanded] = useState<boolean>(false);
  const [currentProductId, setCurrentProductId] = useState<string>("");
  const [productdate, setProductStartDate] = useState<string>("");
  const [mouseState, setMouseState] = React.useState<{
    mouseX: null | number;
    mouseY: null | number;
  }>(initialState);
  const [tabValue, setTabValue] = useState({
    allProducts: true,
    myBids: false,
  });
  const [isLoadingNoProduct, setIsLoadingNoProduct] = useState<boolean>(true);
  const Auth = new AuthService();
  let history = useHistory();
  const { t } = props;
  const eventSource: any = useRef<any>();
  const maxRetryCount = 2;
  const countRef = useRef(0);
  const maxCallApiCount = 1;
  const countAnnualRef = useRef(0);
  const jwlItemPerPageRef = useRef(20);
  const selectJwlPageUseRef = useRef(0);

  const [shouldGetAllData, setShouldGetAllData] = useState(false);
  const dispatch: AppDispatch = useDispatch();

  const isGridView: any = useSelector((state: RootState) =>
    selectGridView(state)
  );

  useEffect(() => {
    setIsLoading(true);
    localStorage.removeItem("dropDownFilterVal");
    // localStorage.removeItem("annualdropDownFilterVal");
    // localStorage.removeItem("filteredAnnualAucValues");
    // localStorage.removeItem("filteredAnnualAucParcelValues");
    //data table api calling
    isReadOnlyUser = localStorage.getItem("isReadOnlyUser");
    isReadOnlyUser = JSON.parse(isReadOnlyUser);

    joinedAuctions = localStorage.getItem("joinedAnnualAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);

    if (joinedAuctions !== null) {
      joinedAuctions.filter((items: any, index: number) => {
        if (items.category === "Jewellery") {
          auctionId = items.perId;
          jwlAuctionUserId = items.auctionUserId;
          auctionDate = items.startDate;
          auctionName = items.name;
        }
      });
    }

    if (auctionId !== undefined) {
      //Event source Connection to the server
      getAllUpdatedData();
      getMyLatestBids(auctionId);
    } else {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
        setApiTimeout(false);
      }, 2000);
    }

    return () => {
      if (eventSource.current !== undefined || eventSource.current !== null) {
        if (eventSource.current?.close !== undefined) {
          eventSource.current?.close();
        }
      }
      dispatch(resetGridProductWatchlistIndexes());
      dispatch(resetjewelleryWatchlistSelectAll());
      localStorage.removeItem("urlProductAuctionFromEmail");
      auctionName = "";
    };
  }, []);

  const selectcurrentApiStartCountValue: any = useSelector((state: RootState) =>
    selectAnnualJewelleryCurrentApiStartCount(state)
  );

  const selectItemPerPageValue: any = useSelector((state: RootState) =>
    selectAnnualJewelleryItemPerPage(state)
  );

  useEffect(() => {
    localStorage.setItem(
      "currentStart",
      JSON.stringify(selectcurrentApiStartCountValue * selectItemPerPageValue)
    );
    if (auctionId !== undefined) {
      getTendorAucProducts(auctionId, selectcurrentApiStartCountValue);
    }
  }, [selectItemPerPageValue, selectcurrentApiStartCountValue]);

  useEffect(() => {
    if (shouldGetAllData) {
      getAllUpdatedData();
      setShouldGetAllData(false);
    }
  }, [shouldGetAllData]);

  const getAllUpdatedData = () => {
    if (countRef.current < maxRetryCount) {
      eventSource.current = new EventSource(
        `${getAnnualBidInfo}?auctionId=${auctionId}`
      );
      eventSource.current.onmessage = (event: any) => {
        updatedRowData = JSON.parse(event.data);
        if (updatedRowData !== undefined) {
          if (updatedRowData.alive) {
            //This will listen only for events
          } else {
            if (auctionId === updatedRowData.auctionId) {
              // previousHighestBidderId = updatedRowData.previousHighestBidder;
              updateRowIndex = auctionProductResult.findIndex(
                (product: any) => product.perId === updatedRowData.perId
              );
              const mapping: any = {};
              if (
                auctionProductResult !== undefined &&
                auctionProductResult.length > 0
              ) {
                auctionProductResult.map((items: any) => {
                  mapping[items.perId] = {
                    watched: items.watched,
                  };
                });
              }
              var updatedArr = update(auctionProductResult, {
                $splice: [[updateRowIndex, 1, updatedRowData]],
              });
              const arr = [...updatedArr];
              // auctionProductResult = updatedArr;
              arr.map((items: any) => {
                if (mapping[items.perId] !== undefined) {
                  items.watched = mapping[items.perId].watched;
                }
              });

              auctionProductResult = arr;
              setAuctionProducts(auctionProductResult);
              setShouldGetAllData(false);
            }
          }
        }
      };
      eventSource.current.onerror = (err: any) => {
        console.error("EventSource failed:", err);
        countRef.current = countRef.current + 1;
        setShouldGetAllData(true);
      };
    }
  };

  const getTendorAucProducts = (
    auctionId: number | string,
    currentPage: number,
    isLoadPreSelectedPage?: boolean
  ) => {
    setOpenToast(false);
    body = [];
    jwlFilteredValues = localStorage.getItem("jwlFilteredValues");
    jwlFilteredValues = JSON.parse(jwlFilteredValues);

    if (jwlFilteredValues !== undefined) {
      if (jwlFilteredValues === null || jwlFilteredValues.length === 0) {
        filter = null;
      } else {
        jwlFilteredValues.map((item: any, index: number) => {
          if (item.name === "auctionId") {
            jwlFilteredValues.splice(index, 1);
          }
        });
        filter = jwlFilteredValues;
      }
    }
    getBody(auctionId, currentPage, endCount, isLoadPreSelectedPage);
  };

  const getBody = (
    auctionId: string | number,
    currentPage: number,
    endCount: number,
    isLoadPreSelectedPage?: boolean
  ) => {
    localStorage.setItem(
      "jwlcurrentPageOfTenderAllProducts",
      currentPage.toString()
    );
    data = {};

    jwlFilteredValues = localStorage.getItem("jwlFilteredValues");
    jwlFilteredValues = JSON.parse(jwlFilteredValues);
    //handle drop downfilter value

    if (
      localStorage.getItem("dropDownFilterVal") !== undefined &&
      localStorage.getItem("dropDownFilterVal") !== null
    ) {
      var tempArr = localStorage.getItem("dropDownFilterVal");
      if (tempArr !== null) var dropDownValues = JSON.parse(tempArr);
      var property = dropDownValues[0].property;
      var direction = dropDownValues[0].direction;
    }

    if (
      selectcurrentApiStartCountValue !== null &&
      selectcurrentApiStartCountValue !== 0
    ) {
      startCount = selectcurrentApiStartCountValue * selectItemPerPageValue;
    } else {
      startCount = selectcurrentApiStartCountValue;
    }

    if (
      selectcurrentApiStartCountValue != null &&
      selectcurrentApiStartCountValue !== 0
    ) {
      page = selectcurrentApiStartCountValue;
    } else {
      page = 0;
    }

    if (selectItemPerPageValue !== null) {
      let savedCount: any = selectItemPerPageValue;
      endCount = savedCount;
    }

    if (totalElement < 20) {
      startCount = 0;
    }

    if (
      filter === null &&
      (jwlFilteredValues === null ||
        jwlFilteredValues === undefined ||
        jwlFilteredValues === "null" ||
        jwlFilteredValues.length === 0)
    ) {
      payload = {
        page: {
          start: isLoadPreSelectedPage ? currentPage * 20 : startCount,
          count: endCount,
          sort: {
            orders: [
              {
                property:
                  property !== null && property !== undefined
                    ? property
                    : "productEndDate",
                direction:
                  direction !== null && direction !== undefined
                    ? direction
                    : "ASC",
              },
            ],
          },
        },
      };
    } else {
      body = jwlFilteredValues ? jwlFilteredValues : filter;
      body.map((item: any, index: number) => {
        if (item.name === "auctionId") {
          body.splice(index, 1);
        }
      });
      payload = {
        page: {
          start: isLoadPreSelectedPage ? currentPage * 20 : startCount,
          count: endCount,
          sort: {
            orders: [
              {
                property:
                  property !== null && property !== undefined
                    ? property
                    : "productEndDate",
                direction:
                  direction !== null && direction !== undefined
                    ? direction
                    : "ASC",
              },
            ],
          },
        },
      };
    }

    let val = localStorage.getItem("optionValue");
    if (val !== "" && val !== "null" && val != null) {
      setOptionValue(val);
      payload = {
        filters: {
          or: [
            {
              match: "anywhere",
              name: "productDescription",
              value: val,
            },
            {
              match: "anywhere",
              name: "remarks",
              value: val,
            },
          ],
        },
        page: {
          start: isLoadPreSelectedPage ? currentPage * 20 : startCount,
          count: endCount,
          sort: {
            orders: [
              {
                property:
                  property !== null && property !== undefined
                    ? property
                    : "productEndDate",
                direction:
                  direction !== null && direction !== undefined
                    ? direction
                    : "ASC",
              },
            ],
          },
        },
      };
    }
    callApi(payload);
  };

  //Note: Get my All LatestBid using this Api

  const callApi = (payload: any) => {
    if (!oAuth()) {
      history.push("/");
    } else {
      Auth.postRequest(
        `${annualMyWatchedProducts}/${auctionId}/watchlist`,
        payload,
        (status: any, response: any) => {
          // setIsLoading(true);
          if (status === 200) {
            if (startCount !== 0 && response.results.length === 0) {
              dispatch(resetAnnualJewelleryCurrentApiStartCount());
              selectJwlPageUseRef.current = 0;
              localStorage.setItem("currentStart", "0");
            } else {
              setAuctionProducts(response.results);
              totalElement = response.totalElements;
              auctionProductResult = response.results;
              setIsDataTableRefresh(!isDataTableRefresh);
              countAnnualRef.current = 0;
              setIsLoadingNoProduct(false);
              setIsLoading(false);
              setOpenToast(false);
            }
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 404) {
            setIsLoading(false);
            setShowAlertMessage(`${t("common:invalidRequest")}`);
            setOnAction(false);
            setAlertType("error");
            setOpenToast(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setOnAction(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        }
      );
    }
  };

  const getMyLatestBids = (auctionId: string) => {
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.getRequest(
        `${annualMyLatestBidsForUser}?auctionId=${auctionId}`,
        (status: number, response: any) => {
          if (status === 200) {
            setIsLoading(false);
            myLatestBidForProduct = response;
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage("Internal Server Error");
            setAlertType("error");
            setOpenToast(false);
          }
        }
      );
    }
  };

  const handleBidClick = (tableData: any) => {
    rowSelectedData = tableData.rowData;
    rowSelectedData = tableData.rowData;
    getProductsDetails(auctionProducts);
    details = tableData.rowIndex;
    setshowTenderSlider(true);
  };

  //rediract from bid now button of Jewellery product details page -------

  const renderAutomaticBidPopup = (data: any) => {
    const rediractProductId: any = localStorage.getItem(
      "currentJewelleryProductIdOfBidNow"
    );
    if (rediractProductId !== null) {
      const indexOfProduct = auctionProducts.findIndex(
        (item: any) => item.perId === rediractProductId
      );
      rowSelectedData = data.rowData;
      details = indexOfProduct;
      if (details !== -1) {
        setshowTenderSlider(true);
      }
      localStorage.removeItem("currentJewelleryProductIdOfBidNow");
    }
  };
  const renderAutomaticBidPopupInMobile = (data: any) => {
    const rediractProductId: any = localStorage.getItem(
      "currentJewelleryProductIdOfBidNow"
    );
    if (rediractProductId !== null) {
      const indexOfProduct = auctionProducts.findIndex(
        (item: any) => item.perId === rediractProductId
      );
      rowSelectedData = data;
      details = indexOfProduct;
      if (details !== -1) {
        setshowTenderSlider(true);
      }
      localStorage.removeItem("currentProductIdOfBidNow");
    }
  };

  const getProductsDetails = (product: any) => {
    length = product.length;
    product.map((items: any, index: any) => {
      if (items.perId === rowSelectedData[columnIndexes.perId]) {
        details = index;
      }
    });
    return details;
  };

  //index of Mobile ui component
  const getBoxIndex = (boxIndex: any) => {
    length = auctionProducts.length;
    details = boxIndex;
    setshowTenderSlider(true);
  };

  const getTableBodyHeight = () => {
    var h = window.innerHeight;
    let heightOfInnerTable: any;
    if (isTableExpanded) {
      heightOfInnerTable = h - 330;
    } else {
      heightOfInnerTable = h - 170;
    }
    if (auctionProducts.length > 2) {
      return `${heightOfInnerTable}px`;
    }
  };

  const options: MUIDataTableOptions = {
    filter: false,
    download: "false",
    print: "false",
    viewColumns: "false",
    count: totalElement,
    page: page,
    serverSide: true,
    search: false,
    rowsPerPage: selectItemPerPageValue,
    rowsPerPageOptions: [0],
    selectableRows: "multiple",
    selectableRowsHeader: true,
    selectableRowsOnClick: false,

    isRowSelectable: (dataIndex: any, selectedRows: any) => {
      const disableRowIndexsArray = getDisableRowIndex();
      return disableRowIndexsArray.includes(dataIndex) ? false : true;
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      return (
        <div className="mailIconDiv">
          <IconButton color="primary">
            <i className="zmdi zmdi-email"></i>
          </IconButton>
        </div>
      );
    },
    onChangePage: (currentPage: number) => {
      // getTendorAucProducts(auctionId, currentPage);
      setIsLoading(true);
      setIsTableExpanded(false);
      localStorage.setItem(
        "currentStart",
        JSON.stringify(currentPage * jwlItemPerPageRef.current)
      );
      dispatch(setAnnualJewelleryCurrentApiStartCount({ currentPage }));
    },
    onSearchChange: (searchTxt: any) => {
      //
    },
    setRowProps: (row: any, dataIndex: any, rowIndex: any) => {
      if (row[columnIndexes.previousHighestBidder] === undefined) {
        if (row[columnIndexes.holdPreviousBidder] === undefined) {
          if (row[columnIndexes.auctionUserId] !== jwlAuctionUserId) {
            return { style: { background: "white" } };
          } else {
            return { style: { background: row[columnIndexes.rowColor] } };
          }
        } else {
          if (jwlAuctionUserId === row[columnIndexes.holdPreviousBidder]) {
            return { style: { background: "#ffeb9c" } };
          } else {
            return { style: { background: row[columnIndexes.rowColor] } };
          }
        }
      } else {
        if (jwlAuctionUserId === row[columnIndexes.previousHighestBidder]) {
          return { style: { background: "#FBE4D5" } };
        } else {
          return { style: { background: row[columnIndexes.rowColor] } };
        }
      }
    },
    onColumnSortChange: (price: any, direction: any) => {
      let order = "";
      if (isSort === false) {
        order = "desc";
      } else {
        order = "asc";
      }
      setIsSort(!isSort);
      sort(price, order);
    },
    onRowSelectionChange: (
      currentRowsSelected: any,
      allRowsSelected: any,
      rowsSelected: any
    ) => {
      indexsForBulkBidItems = rowsSelected;
      setOpenToast(false);
      indexsForBulkBidItems.map((indexs: any) => {
        let {
          sellerAuctionUserId,
          previousHighestBidder,
          auctionUserId,
          holdPreviousBidder,
        } = auctionProducts[indexs];
        if (sellerAuctionUserId === auctionUserId) {
          return { ...options, isRowSelectable: "false" };
        } else if (previousHighestBidder !== undefined) {
          if (auctionUserId === previousHighestBidder) {
            return { ...options, isRowSelectable: "false" };
          }
        } else if (holdPreviousBidder !== undefined) {
          if (auctionUserId === holdPreviousBidder) {
            return { ...options, isRowSelectable: "false" };
          }
        } else if (jwlAuctionUserId === auctionUserId) {
          return { ...options, isRowSelectable: "false" };
        }
      });
      if (indexsForBulkBidItems.length >= 0) {
        setShowBulkBidButton(true);
      } else {
        setShowBulkBidButton(false);
      }
      if (indexsForBulkBidItems.length === 0) {
        setShowBulkBidButton(false);
      }
      if (indexsForBulkBidItems.length > 10) {
        setShowAlertMessage(
          `${t("common:Tender:validation:productSelection")}`
        );
        setAlertType("error");
        setOpenToast(true);
      }
    },
    tableBodyHeight: getTableBodyHeight(),
    textLabels: {
      body: {
        noMatch: isLoadingNoProduct
          ? "Loading data..."
          : `${t("common:watchList:watchlistEmpty")}`,
      },
    },
  };

  const onGridSelectionChange = (rowsSelected: any) => {
    indexsForBulkBidItems = rowsSelected;
    setOpenToast(false);
    if (indexsForBulkBidItems.length >= 0) {
      setShowBulkBidButton(true);
    } else {
      setShowBulkBidButton(false);
    }
    if (indexsForBulkBidItems.length === 0) {
      setShowBulkBidButton(false);
    }
    if (indexsForBulkBidItems.length > 10) {
      setShowAlertMessage(`${t("common:Tender:validation:productSelection")}`);
      setAlertType("error");
      setOpenToast(true);
    }
  };

  //bidding color of bidded section
  const boxColor = (items: any) => {
    const { rowColor, previousHighestBidder, holdPreviousBidder } = items;
    if (previousHighestBidder === undefined) {
      if (holdPreviousBidder === undefined) {
        if (jwlAuctionUserId !== items.auctionUserId) {
          return "white";
        } else {
          return rowColor;
        }
      } else {
        if (jwlAuctionUserId === holdPreviousBidder) {
          return "#ffeb9c";
        } else {
          return rowColor;
        }
      }
    } else {
      if (jwlAuctionUserId === previousHighestBidder) {
        return "#FBE4D5";
      } else {
        return rowColor;
      }
    }
  };

  const getDisableRowIndex = () => {
    return auctionProducts.map((items: any, index: number) => {
      if (isReadOnlyUser) {
        return index;
      } else {
        if (items.sellerAuctionUserId === jwlAuctionUserId) {
          return index;
        } else if (items.previousHighestBidder !== undefined) {
          if (jwlAuctionUserId === items.previousHighestBidder) {
            return index;
          }
        } else if (items.holdPreviousBidder !== undefined) {
          if (jwlAuctionUserId === items.holdPreviousBidder) {
            return index;
          }
        } else if (items.auctionUserId === jwlAuctionUserId) {
          return index;
        }
      }
    });
  };

  //server side sorting
  const filterSort = (price: any, direction: any) => {
    let order = "";
    if (direction === "asc") {
      order = "desc";
    } else {
      order = "asc";
    }
    sort(price, order);
  };

  const sort = (value: any, direction: any) => {
    sortData(value, direction);
  };

  //sorting
  const sortData = (values: any, direction: any) => {
    let tempArr: any = [{ property: values, direction: direction }];

    if (direction === "asc") {
      tempArr = [{ property: values, direction: "ASC" }];
    } else {
      tempArr = [{ property: values, direction: "DESC" }];
    }
    localStorage.setItem("dropDownFilterVal", JSON.stringify(tempArr));
    if (selectcurrentApiStartCountValue === 0) {
      getTendorAucProducts(auctionId, 0);
    } else {
      dispatch(resetAnnualJewelleryCurrentApiStartCount());
    }
    selectJwlPageUseRef.current = 0;
    localStorage.setItem("currentStart", "0");
  };

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "serialNo",
      label: "Serial No",
      options: {
        filter: true,
        sort: true,
        display: true,
        setCellProps: () => ({
          style: { minWidth: "70px", maxWidth: "100px" },
        }),
      },
    },
    {
      name: "perId",
      label: "Product Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "auctionUserId",
      label: "Auction User Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "",
      label: `${t("common:Tender:tableColumnNames:ActionsTender")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                justifyContent: "center",
              }}
            >
              <div
                title={`Note`}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  openProductDetail(
                    auctionId,
                    tableMeta.rowData[1],
                    tableMeta.rowData[columnIndexes.productStartDate]
                  )
                }
              >
                <FontAwesomeIcon
                  icon={faEditProps}
                  style={{ color: "#5b9bd5" }}
                />
              </div>
              <div
                title={`Add Product into Wishlist`}
                style={{ cursor: "pointer" }}
              >
                {isReadOnlyUser ? (
                  <FontAwesomeIcon
                    icon={faHeartProps}
                    style={{ color: "gray" }}
                    onClick={() => {
                      renderReadOnlyUserToast(
                        tableMeta.rowData[columnIndexes.sellerAuctionUserId]
                      );
                    }}
                  />
                ) : (
                  <>
                    {tableMeta.rowData[columnIndexes.sellerAuctionUserId] !==
                      jwlAuctionUserId ? (
                      <>
                        {getWatchedProduct(
                          tableMeta.rowData[columnIndexes.watched],
                          tableMeta.rowData[columnIndexes.perId],
                          auctionId,
                          tableMeta.rowData[1]
                        )}
                      </>
                    ) : (
                      <FontAwesomeIcon
                        icon={faHeartProps}
                        style={{ color: "gray" }}
                        onClick={() => {
                          renderReadOnlyUserToast(
                            tableMeta.rowData[columnIndexes.sellerAuctionUserId]
                          );
                        }}
                      />
                    )}
                  </>
                )}
              </div>
              <div
                title={`Share Product`}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  shareButtonAction(
                    tableMeta.rowData[columnIndexes.perId],
                    tableMeta.rowData[columnIndexes.productStartDate]
                  )
                }
              >
                <FontAwesomeIcon
                  icon={faShareSquareProps}
                  style={{ color: "#5b9bd5" }}
                />
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "productEndDate",
      label: `${t("common:newCommanTrans:timeleft")}`,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "150px", maxWidth: "150px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          if (tableMeta.rowData[columnIndexes.productExtended] !== undefined) {
            if (tableMeta.rowData[columnIndexes.productExtended]) {
              return (
                <span style={{ color: "red" }}>{productTimeLeft(value)}</span>
              );
            } else {
              return <span>{productTimeLeft(value)}</span>;
            }
          }
        },
      },
    },
    {
      name: "code",
      label: `${t("common:Tender:tableColumnNames:sku")}`,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <span
              className="linkCss"
              onClick={() =>
                openProductDetail(
                  auctionId,
                  tableMeta.rowData[1],
                  tableMeta.rowData[columnIndexes.productStartDate]
                )
              }
              onContextMenu={(event: any) =>
                rightClickEvent(
                  event,
                  tableMeta.rowData[1],
                  tableMeta.rowData[columnIndexes.productStartDate]
                )
              }
            >
              {value}
            </span>
          );
        },
      },
    },
    {
      name: "lab",
      label: `${t("common:Tender:tableColumnNames:lab")}`,
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "certificate",
      label: `${t("common:Tender:tableColumnNames:certification")}`,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "150px", maxWidth: "150px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          if (
            tableMeta.rowData[columnIndexes.lab] !== "AGT" &&
            tableMeta.rowData[columnIndexes.lab] !== "agt" &&
            tableMeta.rowData[columnIndexes.lab] !== "" &&
            tableMeta.rowData[columnIndexes.lab] !== undefined
          ) {
            return (
              <span
                className="linkCss"
                onClick={() =>
                  openJewelleryCertificateLinkPopup(
                    tableMeta.rowData[columnIndexes.lab],
                    tableMeta.rowData[columnIndexes.certificate]
                  )
                }
              >
                {value}
              </span>
            );
          } else {
            return <span>{value}</span>;
          }
        },
      },
    },
    {
      name: "jewelleryDetails",
      label: `${t("common:Tender:tableColumnNames:description")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return (
            <EllipsisText
              text={getDescription(value)}
              length={70}
              tail={"..."}
            />
          );
        },
      },
    },
    {
      name: "currency",
      label: "currency",
      options: {
        display: false,
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return <div>{value?.code}</div>;
        },
      },
    },
    {
      name: "remarks",
      label: `${t("common:Tender:tableColumnNames:remark")}`,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <EllipsisText
              text={getRemarks(tableMeta.rowData[columnIndexes.remarks])}
              length={30}
              tail={"..."}
            />
          );
        },
      },
    },
    {
      name: "notes",
      label: `${t("common:Tender:tableColumnNames:notes")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "caratMinimumPrice",
      label: `${t("common:Tender:tableColumnNames:jewelleryPrice")}`,
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "myLatestBid",
      label: `${t("common:Tender:tableColumnNames:placeBid")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              {isDataRefresh ? (
                <div>
                  {value === undefined || value === null
                    ? 0
                    : handelMyBidsLabel(
                      myLatestBidForProduct,
                      tableMeta.rowData[columnIndexes.perId],
                      tableMeta.rowData[columnIndexes.currency],
                      tableMeta.rowData[columnIndexes.exchangeRate][0].rate
                    )}
                </div>
              ) : (
                <div>
                  {value === undefined || value === null
                    ? 0
                    : handelMyBidsLabel(
                      myLatestBidForProduct,
                      tableMeta.rowData[columnIndexes.perId],
                      tableMeta.rowData[columnIndexes.currency],
                      tableMeta.rowData[columnIndexes.exchangeRate][0].rate
                    )}
                </div>
              )}
              {getBidNowButtonDisable(
                tableMeta.rowData[columnIndexes.sellerAuctionUserId],
                jwlAuctionUserId,
                tableMeta.rowData[columnIndexes.auctionUserId],
                tableMeta,
                getReturnMyLatestStoredBid(
                  myLatestBidForProduct,
                  tableMeta.rowData[columnIndexes.perId]
                ),
                tableMeta.rowData[columnIndexes.currentBidPrice],
                tableMeta.rowData[columnIndexes.perId],
                tableMeta.rowData[columnIndexes.previousHighestBidder],
                tableMeta.rowData[columnIndexes.holdPreviousBidder]
              )}
            </>
          );
        },
      },
    },
    {
      name: "currentBidPrice",
      label: `${t("common:Tender:tableColumnNames:liveHighestBid")}`,
      options: {
        filter: true,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "noOfBidders",
      label: `${t("common:newCommanTrans:noOfBiddersBids")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {getNoOfBiddersAndNoOfBids(
                tableMeta.rowData[columnIndexes.noOfBids],
                tableMeta.rowData[columnIndexes.noOfBidders]
              )}
            </div>
          );
        },
      },
    },
    {
      name: "rowColor",
      label: "Bid Color",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "exchangeRates",
      label: "Exchange Rate",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value: any) => {
          return <div>{value[0].rate}</div>;
        },
      },
    },
    {
      name: "myLatestBid",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "currentBidPrice",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "noOfBids",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "watched",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "sellerAuctionUserId",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "tenderSecondHighestBid",
      label: `${t("common:Tender:tableColumnNames:liveHighestBid")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "previousHighestBidder",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "productStartDate",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "productExtended",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "holdPreviousBidder",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
  ];

  //get bid now button disable
  const getBidNowButtonDisable = (
    sellerId: any,
    auctionUserIdForProduct: any,
    tableAuctionUserId: any,
    tableDataForUIBox: any,
    myBidsForProduct: any,
    currentBidPriceForProduct: any,
    currentproductId: any,
    previousBidderId: any,
    holdPreviousBidder: any
  ) => {
    renderAutomaticBidPopup(tableDataForUIBox);
    if (isReadOnlyUser) {
      return (
        <StyledBtnContainer
          onClick={() => {
            renderReadOnlyUserToast(sellerId);
          }}
        >
          <StyledButtonGray>
            {t("common:inquiry:button:bidNow")}
          </StyledButtonGray>
        </StyledBtnContainer>
      );
    } else {
      if (sellerId === auctionUserIdForProduct) {
        return (
          <StyledBtnContainer
            onClick={() => {
              renderReadOnlyUserToast(sellerId);
            }}
          >
            <StyledButtonGray>
              {t("common:inquiry:button:bidNow")}
            </StyledButtonGray>
          </StyledBtnContainer>
        );
      } else if (holdPreviousBidder !== undefined) {
        if (jwlAuctionUserId === holdPreviousBidder) {
          return (
            <StyledBtnContainer>
              <StyledButtonGray>
                {t("common:inquiry:button:bidNow")}
              </StyledButtonGray>
            </StyledBtnContainer>
          );
        } else {
          return (
            <StyledBtnContainer>
              <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
                {t("common:inquiry:button:bidNow")}
              </StyledButton>
            </StyledBtnContainer>
          );
        }
      } else if (previousBidderId !== undefined) {
        if (jwlAuctionUserId === previousBidderId) {
          return (
            <StyledBtnContainer>
              <StyledButtonGray>
                {t("common:inquiry:button:bidNow")}
              </StyledButtonGray>
            </StyledBtnContainer>
          );
        } else {
          return (
            <StyledBtnContainer>
              <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
                {t("common:inquiry:button:bidNow")}
              </StyledButton>
            </StyledBtnContainer>
          );
        }
      } else if (tableAuctionUserId === jwlAuctionUserId) {
        return (
          <StyledBtnContainer>
            <StyledButtonGray>
              {t("common:inquiry:button:bidNow")}
            </StyledButtonGray>
          </StyledBtnContainer>
        );
      } else {
        if (tableAuctionUserId === jwlAuctionUserId) {
          return (
            <StyledBtnContainer>
              <StyledButtonGray>
                {" "}
                {t("common:inquiry:button:bidNow")}
              </StyledButtonGray>
            </StyledBtnContainer>
          );
        } else {
          return (
            <StyledBtnContainer>
              <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
                {t("common:inquiry:button:bidNow")}
              </StyledButton>
            </StyledBtnContainer>
          );
        }
      }
    }
  };
  //get My All MyBid
  const handelMyBidsLabel = (
    myStoredBids: any,
    currentProductId: any,
    currency: any,
    exchangeRate: any
  ) => {
    const Obj = myLatestBidForProduct.filter(
      (item: any) => item.productId === currentProductId
    );
    const mybidPriceforProduct = Obj.map((item: any, index: number) => {
      return item.productId;
    });

    return getMyLatestStoredBids(
      myLatestBidForProduct,
      currentProductId,
      currency,
      exchangeRate,
      mybidPriceforProduct
    );
  };

  const shareButtonAction = (perId: any, productStartDate: any) => {
    const { t } = props;
    date = productStartDate.split(" ", 2);
    let languageCode =
      localStorage.getItem("language") === "EN"
        ? "en"
        : localStorage.getItem("language") === "zh_CN"
          ? "zh_CN"
          : "jp";
    copy(
      `${window.location.hostname}/${languageCode}/product/jewellery/${perId}/${date[0]}/detail`
    );
    setAlertType("success");
    setOpenToast(true);
    setShowAlertMessage(`${t("common:preview:linkCopied")}`);
    setTimeout(() => {
      setOpenToast(false);
    }, 2000);
  };

  const getNoOfBiddersAndNoOfBids = (noOfBidders: any, noOfBids: any) => {
    return `${noOfBidders}/${noOfBids}`;
  };

  const getRemarks = (remarks: any) => {
    if (remarks !== "" && remarks !== undefined && remarks !== null) {
      return remarks;
    } else {
      return "";
    }
  };

  const getDescription = (jewelleryDetails: any) => {
    var jewelleryType: string = "";
    var jewelleryCondition: string = "";
    var jewelleryDescription: string = "";
    if (jewelleryDetails !== undefined && jewelleryDetails !== null) {
      if (
        jewelleryDetails.jewelleryType !== undefined &&
        jewelleryDetails.jewelleryType !== null
      ) {
        jewelleryType = jewelleryDetails.jewelleryType;
      } else {
        jewelleryType = "";
      }

      if (
        jewelleryDetails.jewelleryCondition !== undefined &&
        jewelleryDetails.jewelleryCondition !== null
      ) {
        jewelleryCondition = jewelleryDetails.jewelleryCondition;
      } else {
        jewelleryCondition = "";
      }

      if (
        jewelleryDetails.jewelleryDescription !== undefined &&
        jewelleryDetails.jewelleryDescription !== null
      ) {
        jewelleryDescription = jewelleryDetails.jewelleryDescription;
      } else {
        jewelleryDescription = "";
      }
    }

    return (
      jewelleryType + " " + jewelleryCondition + " " + jewelleryDescription
    );
  };

  const closeModal = () => {
    Auth.logout();
    props.history.replace("/");
  };

  // Tender bulk bid popup
  const handleBtnValue = (
    values: number,
    currentBidPrice: any,
    productId: any,
    myBidValues: any
  ) => {
    var data = [
      {
        bidIncreasedBy: values,
        bidPrice: currentBidPrice,
        auctionUserId: jwlAuctionUserId,
        auctionId: auctionId,
        productId: productId,
      },
    ];
    let updateRowIndex = myLatestBidForProduct.findIndex(
      (product: any) => product.productId === myBidValues.productId
    );
    if (updateRowIndex === -1) {
      var myLatestBidForProductObjectData: any = [
        ...myLatestBidForProduct,
        myBidValues,
      ];
      myLatestBidForProduct = myLatestBidForProductObjectData;
    } else {
      var updatedArray = update(myLatestBidForProduct, {
        $splice: [[updateRowIndex, 1, myBidValues]],
      });
      myLatestBidForProduct = updatedArray;
    }
    bidProduct(data);
    PubSub.publish("resetAnnualGridBoxIndex", []);
  };

  const bulkBidHandler = (values: any[], myBidBulkValues: any) => {
    myLatestBidForProduct = myBidBulkValues;
    bidProduct(values);
    onGridSelectionChange(0);
    PubSub.publish("resetAnnualGridBoxIndex", []);
    onGridSelectionChange(0);
    PubSub.publish("resetAnnualGridBoxIndex", []);
    dispatch(resetGridProductWatchlistIndexes());
    dispatch(resetjewelleryWatchlistSelectAll());
    // PubSub.publish("jewellerySelectAllCheckBoxWatchlist", { isItemSelected: false, selectedIndexes: [] });
    setIsSelected(false);
  };

  const bidProduct = (payloadBid: any) => {
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        annualBidUrl,
        payloadBid,
        (status: any, response: any) => {
          if (status === 200) {
            setIsDataRefresh(!isDataRefresh);
            getMyLatestBids(auctionId);
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setOnAction(false);
          } else if (status === 404) {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(`${t("common:invalidRequest")}`);
            setAlertType("error");
            setOpenToast(true);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        }
      );
    }
  };

  const renderer = ({
    formatted: { days, hours, minutes, seconds },
    completed,
  }: any) => {
    if (completed) {
      if (
        days === "00" &&
        hours === "00" &&
        minutes === "00" &&
        seconds === "00"
      ) {
        getExtendedTime();
        return <span>00:00:00:00</span>;
      }
    } else {
      return (
        <span>
          {days}:{hours}:{minutes}:{seconds}
        </span>
      );
    }
  };

  const getExtendedTime = () => {
    if (countAnnualRef.current < maxCallApiCount) {
      closebidPopup();
      getTendorAucProducts(auctionId, 0);
      countAnnualRef.current = countAnnualRef.current + 1;
    }
  };

  const getExtendedTimeGrid = (pagenum: any) => {
    if (countAnnualRef.current < maxCallApiCount) {
      closebidPopup();
      getTendorAucProducts(auctionId, pagenum);
      countAnnualRef.current = countAnnualRef.current + 1;
    }
  };

  const productTimeLeft = (startDate: any) => {
    let date: string | null = "";
    let time: string | null = "";
    let timezone: any = "";

    if (startDate !== null || startDate !== undefined) {
      let previewTime = moment.utc(startDate);
      if (timezone !== null) {
        timezone = localStorage.getItem("timezoneName");
      }
      if (previewTime !== null || previewTime !== undefined) {
        let result = moment.tz(previewTime, timezone);
        let resultFormatter = result.format();
        if (resultFormatter !== "Invalid date") {
          let splitDateTime = resultFormatter.split("T", 2);
          let splitTime: any = "";
          if (splitDateTime[1].includes("+")) {
            splitTime = splitDateTime[1].split("+", 2);
          } else {
            splitTime = splitDateTime[1].split("-", 2);
          }
          date = splitDateTime[0];
          time = splitTime[0];
          let dateTime = `${date} ${time}`;
          let end: any = moment(dateTime);
          timezone = localStorage.getItem("timezoneName");
          let start: any = moment(
            new Date().toLocaleString("en-US", { timeZone: timezone })
          );
          var timeDiff = end - start;
          seconds = Math.round(timeDiff);
        }
      }
    }
    return (
      <Countdown
        date={Date.now() + seconds}
        className="countdownText"
        renderer={renderer}
        zeroPadTime={2}
      />
    );
  };

  const setItemsPerPageHandler = (itemsPerPage: number) => {
    localStorage.setItem("jwlcurrentPageOfTenderAllProducts", "0");
    setCurrentPage(1);
    setItemsPerPage(itemsPerPage);
    jwlItemPerPageRef.current = itemsPerPage;
    dispatch(setAnnualJewelleryItemPerPage({ itemsPerPage }));
    dispatch(resetAnnualJewelleryCurrentApiStartCount());
  };

  function setCurrentPage(currentPage: number) {
    return currentPage;
  }

  function setItemsPerPage(itemsPerPage: number) {
    return itemPerPage(true, 0, itemsPerPage);
  }

  const itemPerPage = (value: boolean, start: number, itemPerPage: number) => {
    if (value === true) {
      localStorage.setItem("annualitemsPerPage", JSON.stringify(itemPerPage));
      getUpdatedProducts(value, start, itemPerPage);
    }
  };

  const getUpdatedProducts = (value: any, start: any, endRecords: any) => {
    if (value === true) {
      getProducts(start, endRecords);
    }
  };

  const getProducts = (start: number, itemsPerPage: number) => {
    startCount = start;
    endCount = itemsPerPage;
    localStorage.setItem("currentStart", JSON.stringify(start));
    let Page: any = localStorage.getItem("jwlcurrentPageOfTenderAllProducts");
    // getBody(auctionId, parseInt(Page), itemsPerPage);
    let currentPage = start / itemsPerPage;

    dispatch(setAnnualJewelleryCurrentApiStartCount({ currentPage }));
    dispatch(setAnnualJewelleryItemPerPage({ itemsPerPage }));
    PubSub.publish("resetAnnualGridBoxIndex", []);
    setIsSelected(false);
    dispatch(resetGridProductWatchlistIndexes());
    dispatch(resetjewelleryWatchlistSelectAll());
    // PubSub.publish("jewellerySelectAllCheckBoxWatchlist", { isItemSelected: false, selectedIndexes: [] });
    onGridSelectionChange(0);
    setIsLoading(true);
  };

  const theme = useTheme();
  const notSmallDevices = useMediaQuery(theme.breakpoints.between("md", "xl"));
  let isAuctionPage: any = true;
  let isCategoryPageType: any = false;

  const handleMyBids = (auctionsProduct: any) => {
    if (auctionsProduct.length > 0) {
      setAuctionProducts(auctionsProduct);
    }
  };

  const addToWatchList = (
    productId: string | number,
    auctionId: string | number
  ) => {
    setOnAction(true);
    setOpenToast(false);
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        `${productUrl}/${auctionId}/${productId}/watch`,
        "payload",
        (status: any, response: any) => {
          if (response !== undefined) {
            if (status === 200) {
              callApi(payload);
              setIsTableExpanded(false);
              setIsLoading(false);
              setOnAction(false);
              setShowAlertMessage(`${t("common:preview:addedToWatchMsg")}`);
              setAlertType("success");
              setOpenToast(true);
            }
          }
        }
      );
    }
  };

  //get Watched Product
  const getWatchedProduct = (
    watched: any,
    productId: any,
    auctionId: any,
    serialNo: any
  ) => {
    return (
      <FontAwesomeIcon
        icon={faHeartProps}
        style={{ color: "red", cursor: "pointer" }}
        onClick={() => {
          removeFromWatchlist(productId, auctionId);
        }}
      />
    );
  };

  const removeFromWatchlist = (
    productId: string | number,
    auctionId: string | number
  ) => {
    setOnAction(true);
    setOpenToast(false);
    if (Auth.loggedIn() === null) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        `${productUrl}/${auctionId}/${productId}/unwatch`,
        "payload",
        (status: any, response: any) => {
          if (status === 200) {
            // callApi(payload);
            setIsLoadingNoProduct(true);
            setIsLoading(true);
            getTendorAucProducts(auctionId, selectJwlPageUseRef.current);
            setIsTableExpanded(false);
            setOnAction(false);
            setShowAlertMessage(response.data.message);
            setAlertType("success");
            setOpenToast(true);
          }
        }
      );
    }
  };

  const openProductDetail = (
    auctionId: string,
    perId: string,
    productStartDate: string
  ) => {
    date = productStartDate.split(" ", 2);
    props.history.push(
      `/365products/details/${auctionId}/${jwlAuctionUserId}/${perId}/${date[0]}?auctionType=Jewellery`
    );
    dispatch(resetAnnualJewelleryItemPerPage());
    dispatch(resetAnnualJewelleryCurrentApiStartCount());
  };

  const openDetailsView = (
    auctionId: string,
    perId: string,
    productStartDate: string
  ) => {
    date = productStartDate.split(" ", 2);
    const language = localStorage.getItem("language");

    const languageCode =
      language === "EN" ? "en" : language === "zh_CN" ? "zh_CN" : "jp";
    window.open(
      `/${languageCode}/365products/details/${auctionId}/${jwlAuctionUserId}/${perId}/${date[0]}?auctionType=Jewellery`,
      "_blank"
    );
    dispatch(resetAnnualJewelleryItemPerPage());
    dispatch(resetAnnualJewelleryCurrentApiStartCount());
  };

  const rightClickEvent = (
    event: React.MouseEvent<HTMLDivElement>,
    productId: string,
    productStartDate: string
  ) => {
    event.preventDefault();
    setMouseState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
    setCurrentProductId(productId);
    setProductStartDate(productStartDate);
  };

  const handleClose = () => {
    setMouseState(initialState);
  };
  const listGridview = () => {
    selectJwlPageUseRef.current = startCount;
    setUiBoxView(true);
    dispatch(setIsGridView({ gridView: true }));
  };

  const Gridview = () => {
    dispatch(resetIsGridView());
    setUiBoxView(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  const renderReadOnlyUserToast = async (id: any) => {
    var joinedAuctions: any = localStorage.getItem("joinedAnnualAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);
    if (joinedAuctions !== null) {
      joinedAuctions.filter((items: any, index: number) => {
        if (items.category === "Jewellery") {
          if (id === items.auctionUserId) {
            isAuctionUserId = true;
          }
        }
      });
    } else {
      isAuctionUserId = false;
    }
    await renderPopup();
  };

  const renderPopup = () => {
    if (isReadOnlyUser) {
      setOpenReadOnlyUserToast(true);
    } else if (isAuctionUserId) {
      setOpenReadOnlyUserToast(true);
    } else {
      setOpenReadOnlyUserToast(false);
    }
    setTimeout(() => {
      setOpenReadOnlyUserToast(false);
    }, 3000);
  };

  const isSticky = (e: any) => {
    const header: any = document.querySelector(".AccordionHeader");
    const scrollTop = window.scrollY;
    const className =
      scrollTop >= 10
        ? header?.classList.add("AccordionHeaderscroll")
        : header?.classList.remove("AccordionHeaderscroll");
  };

  const handleChangeAcco =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
      if (isExpanded === false) {
        setIsTableExpanded(false);
      } else {
        setIsTableExpanded(true);
      }
    };

  useEffect(() => {
    let isShowDrawerIcon: any = localStorage.getItem("isShowDrawerIcon");
    isShowDrawerIcon = JSON.parse(isShowDrawerIcon);
    if (isShowDrawerIcon !== null) {
      if (isShowDrawerIcon) {
        const accordionHeader: any = document.querySelector(".AccordionHeader");
        if (accordionHeader !== null) {
          accordionHeader.style.width = isShowDrawerIcon
            ? "calc(100% - 60px)"
            : "calc(100% - 240px)";
        }
      }
    }
  });

  const closebidPopup = () => {
    setshowTenderSlider(false);
    setShowBulkBidPopup(false);
    // PubSub.publish("resetAnnualGridBoxIndex", []);
  };

  const exportExcel = () => {
    Auth.postRequestForExcel(
      `${productDownload}?auctionId=${auctionId}&auctionType=Annual&auctionProductsType=watched`,
      { ids: "" },
      (status: any, response: any) => {
        if (status === 200) {
          if (response !== undefined) {
            const url = window.URL.createObjectURL(
              new Blob([response], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Products.xlsx`);
            document.body.appendChild(link);
            link.click();
          }
        }
      }
    );
  };

  const selectAllInGridView = () => {
    //calling select all function in grid View
    let arr: any = [];
    auctionProducts.map((productVal: any, index: any) => {
      if (arr.length < 10) {
        if (isReadOnlyUser) {
          //
        } else {
          if (productVal.sellerAuctionUserId === jwlAuctionUserId) {
            //
          } else if (productVal.holdPreviousBidder !== undefined) {
            if (jwlAuctionUserId === productVal.holdPreviousBidder) {
              //
            } else {
              //add
              arr = [...arr, index];
            }
          } else if (productVal.previousBidderId !== undefined) {
            if (jwlAuctionUserId === productVal.previousBidderId) {
              //
            } else {
              //add
              arr = [...arr, index];
            }
          } else if (productVal.auctionUserId === jwlAuctionUserId) {
            //
          } else {
            if (productVal.auctionUserId === jwlAuctionUserId) {
              //
            } else {
              //add
              arr = [...arr, index];
            }
          }
        }
      }
    });

    if (isSelected) {
      setIsSelected(false);
      PubSub.publish("resetAnnualGridBoxIndex", []);
      arr = [];
      dispatch(resetGridProductWatchlistIndexes());
      dispatch(resetjewelleryWatchlistSelectAll());
    } else {
      setIsSelected(true);
      dispatch(setGridProductWatchlistIndexes({ indexes: arr }));
      dispatch(setjewelleryWatchlistSelectAll({ isSelected: true }));
    }
  };

  return (
    <Grid>
      {apiTimeout === true ? (
        <ApiTimeout {...props} t={t} />
      ) : (
        <>
          {isLoading === true ? (
            <div className="loader">
              <LoadingSpinner />
            </div>
          ) : (
            <StyledLayoutGridMain>
              {isTopElementHide ? null : (
                <Accordion
                  onChange={handleChangeAcco("panel1")}
                  style={{
                    position: "fixed",
                    right: "0",
                    animation: "fadeMe 1s",
                  }}
                  className="AccordionHeader"
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon
                        style={{
                          transform: expanded
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      />
                    }
                  ></AccordionSummary>
                  <div style={{ width: "100%", display: "block" }}>
                    <StyledHeaderContainer container={true} spacing={0}>
                      <StyledCoreDataGridContainer container={true} spacing={0}>
                        <StyledActionBarContainer
                          container={true}
                          spacing={0}
                          className="coreActionBarContainer"
                        >
                          <Grid container={true} xs={12} lg={3} xl={2}>
                            <StyledBackImageContianer>
                              <StyledBackBtn
                                src="/images/controls/left_arrow_round_edges.png"
                                onClick={handleBackBtns}
                              />
                            </StyledBackImageContianer>
                            <Grid>
                              {/* <ItemsCountofProduct
                                t={t}
                                itemsPerPage={jwlItemPerPageRef.current}
                                totalElements={totalElement}
                                currentPage={selectJwlPageUseRef.current}
                              /> */}
                            </Grid>
                          </Grid>
                          <StyledActionsContainer
                            item={true}
                            xs={12}
                            lg={9}
                            xl={10}
                          >
                            {notSmallDevices ? (
                              <>
                                {isGridView === true ? (
                                  <StyledSelectAllButtonHeader
                                    onClick={selectAllInGridView}
                                  >
                                    {t("common:newCommanTrans:selectAll")}
                                  </StyledSelectAllButtonHeader>
                                ) : null}
                              </>
                            ) : (
                              <StyledSelectAllButtonHeader
                                onClick={selectAllInGridView}
                              >
                                {t("common:newCommanTrans:selectAll")}
                              </StyledSelectAllButtonHeader>
                            )}
                            {showBulkBidButton === true ? (
                              <StyledButtonHeader
                                onClick={() => {
                                  setShowBulkBidPopup(true);
                                }}
                              >
                                {t("common:preview:tendor:bulkBid")}
                              </StyledButtonHeader>
                            ) : (
                              <></>
                            )}
                            <StyledButtonHeader onClick={exportExcel}>
                              {t("common:preview:pagination:export")}
                            </StyledButtonHeader>
                            <JewelleryAnnualActionPage
                              setItemsPerPageHandler={setItemsPerPageHandler}
                              t={t}
                            />
                            {notSmallDevices ? (
                              <>
                                {isGridView === true ? (
                                  <StyledButtonView onClick={Gridview}>
                                    <Styledview src="/images/view/listView.png" />
                                  </StyledButtonView>
                                ) : (
                                  <StyledButtonView onClick={listGridview}>
                                    <Styledview src="/images/view/gridview.jpeg" />
                                  </StyledButtonView>
                                )}
                              </>
                            ) : null}
                          </StyledActionsContainer>
                        </StyledActionBarContainer>
                      </StyledCoreDataGridContainer>
                    </StyledHeaderContainer>
                  </div>
                </Accordion>
              )}

              <StyledLayoutGrid
                container={true}
                style={{
                  paddingTop: notSmallDevices
                    ? isTableExpanded
                      ? "125px"
                      : "10px"
                    : "15px",
                }}
              >
                <>
                  <Grid item xs={12}>
                    <StyledName>
                      <StyledContent>
                        <EllipsisText
                          text={auctionName}
                          length={28}
                          tail={"..."}
                        />
                      </StyledContent>
                    </StyledName>
                  </Grid>

                  {isGridView === false && notSmallDevices && (
                    <MuiThemeProvider theme={getMuiTheme()}>
                      {isDataTableRefresh ? (
                        <MUIDataTable
                          title={""}
                          data={auctionProducts}
                          columns={columns}
                          options={options}
                        />
                      ) : (
                        <MUIDataTable
                          title={""}
                          data={auctionProducts}
                          columns={columns}
                          options={options}
                        />
                      )}
                    </MuiThemeProvider>
                  )}

                  {isGridView === true ? (
                    notSmallDevices && (
                      <>
                        <JwlProductGridDataParent
                          t={t}
                          data={auctionProducts}
                          totalElements={totalElement}
                          itemPerPage={itemPerPage}
                          value={getUpdatedProducts}
                          noProductFound={handleMyBids}
                          jwlItemPerPageRef={selectItemPerPageValue}
                          selectJwlPageUseRef={selectJwlPageUseRef.current}
                        >
                          {auctionProducts.length > 0 ? (
                            <ProductGridDataChildComponentWatchlist
                              {...props}
                              watchlist={addToWatchList}
                              unWatchlist={removeFromWatchlist}
                              setShowBidPopupBidModal={getBoxIndex}
                              auctionName={auctionName}
                              auctionDate={date[0]}
                              t={t}
                              isAuctionPage={isAuctionPage}
                              isCategoryPageType={isCategoryPageType}
                              auctionUserId={jwlAuctionUserId}
                              boxColor={boxColor}
                              sortingValue={filterSort}
                              bulkBidIndexHandler={onGridSelectionChange}
                              myForProductAllProduct={myLatestBidForProduct}
                              renderAutomaticBidPopupInMobile={
                                renderAutomaticBidPopupInMobile
                              }
                              renderReadOnlyUserToast={renderReadOnlyUserToast}
                              isRefreshData={getExtendedTimeGrid}
                              rightClickEvent={rightClickEvent}
                            />
                          ) : (
                            <Grid container={true} spacing={0}>
                              <StyledTextWrapper item xs={12}>
                                {t("common:watchList:watchlistEmpty")}
                              </StyledTextWrapper>
                            </Grid>
                          )}
                        </JwlProductGridDataParent>
                      </>
                    )
                  ) : (
                    <> </>
                  )}

                  {notSmallDevices || (
                    <>
                      <JwlProductGridDataParent
                        t={t}
                        data={auctionProducts}
                        totalElements={totalElement}
                        itemPerPage={itemPerPage}
                        value={getUpdatedProducts}
                        noProductFound={handleMyBids}
                        jwlItemPerPageRef={selectItemPerPageValue}
                        selectJwlPageUseRef={selectJwlPageUseRef.current}
                      >
                        {auctionProducts.length > 0 ? (
                          <ProductGridDataChildComponentWatchlist
                            {...props}
                            watchlist={addToWatchList}
                            unWatchlist={removeFromWatchlist}
                            setShowBidPopupBidModal={getBoxIndex}
                            auctionName={auctionName}
                            auctionDate={date[0]}
                            t={t}
                            isAuctionPage={isAuctionPage}
                            isCategoryPageType={isCategoryPageType}
                            auctionUserId={jwlAuctionUserId}
                            sortingValue={filterSort}
                            boxColor={boxColor}
                            bulkBidIndexHandler={onGridSelectionChange}
                            myForProductAllProduct={myLatestBidForProduct}
                            renderAutomaticBidPopupInMobile={
                              renderAutomaticBidPopupInMobile
                            }
                            renderReadOnlyUserToast={renderReadOnlyUserToast}
                            isRefreshData={getExtendedTimeGrid}
                            rightClickEvent={rightClickEvent}
                          />
                        ) : (
                          <Grid container={true} spacing={0}>
                            <StyledTextWrapper item xs={12}>
                              {t("common:watchList:watchlistEmpty")}
                            </StyledTextWrapper>
                          </Grid>
                        )}
                      </JwlProductGridDataParent>
                    </>
                  )}
                </>
                <Menu
                  keepMounted
                  open={mouseState.mouseY !== null}
                  onClose={handleClose}
                  anchorReference="anchorPosition"
                  anchorPosition={
                    mouseState.mouseY !== null && mouseState.mouseX !== null
                      ? { top: mouseState.mouseY, left: mouseState.mouseX }
                      : undefined
                  }
                >
                  <MenuItem
                    onClick={() =>
                      openDetailsView(auctionId, currentProductId, productdate)
                    }
                  >
                    Details
                  </MenuItem>
                </Menu>
                {onAction === true && (
                  <div className="loading">
                    <LoadingSpinner />
                  </div>
                )}

                {userBlock === true && (
                  <StyledModal open={userBlock}>
                    <BlockUserModal t={t} {...props} closeModal={closeModal} />
                  </StyledModal>
                )}

                {openReadOnlyUserToast === true && (
                  <AlertReadOnlyUser
                    isReadOnlyUser={isReadOnlyUser}
                    isSeller={isAuctionUserId}
                  />
                )}
                {showTenderSlider === true && (
                  <StyledModal open={showTenderSlider} onClose={closebidPopup}>
                    <ProductBiddingUiWatchlist
                      t={t}
                      {...props}
                      items={auctionProducts}
                      currentIndex={details}
                      PopupClose={closebidPopup}
                      handleBtnValue={handleBtnValue}
                      auctionDate={date[0]}
                      totalElements={totalElement}
                      endCount={endCount}
                      auctionUserId={jwlAuctionUserId}
                      length={length}
                      boxColor={boxColor}
                      watchedFunction={addToWatchList}
                      unwatched={removeFromWatchlist}
                    />
                  </StyledModal>
                )}
                {showBulkBidPopup === true && (
                  <StyledModal open={showBulkBidPopup} onClose={closebidPopup}>
                    <AnnualBidPopup
                      {...props}
                      items={auctionProducts}
                      popupClose={closebidPopup}
                      handleBtnValue={bulkBidHandler}
                      auctionUserId={jwlAuctionUserId}
                      length={length}
                      productIndexs={indexsForBulkBidItems}
                      myLatestBidForProducts={myLatestBidForProduct}
                      isJewellery={true}
                    />
                  </StyledModal>
                )}
              </StyledLayoutGrid>
            </StyledLayoutGridMain>
          )}
        </>
      )}
    </Grid>
  );
};

export default JewelleryProductAuctionWatchlist;
